import React, { ReactElement, useEffect, useState } from 'react';
import { ImageCustom } from '../../../../common/components/ImageCustom';
import diamondIcon from '../../../../assets/png/diamond.png';
import pointEffectGif from '../../../../assets/png/effect_vs.gif';
import './LiveMatchPoint.scss';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';
import { convertDataToUID } from '../../../../common/utils/utils';

const LiveMatchPoint = (): ReactElement => {
  const { liveCompetitions, liveMatchData } = useSelector(
    (state: AppState) => state.liveMatch,
  );
  const liveData = useSelector((state: AppState) => state.live.liveData);

  const [liveScore, setLiveScore] = useState<number>(0);
  const [targetScore, setTargetScore] = useState<number>(0);

  useEffect(() => {
    if (liveCompetitions) {
      handleUpdateScore();
    }
  }, [liveCompetitions?.scores, liveMatchData]);

  const handleUpdateScore = () => {
    const hashUserLive = convertDataToUID(liveMatchData?.live.user.id);
    const hashUserTarget = convertDataToUID(liveMatchData?.target.user.id);
    const elementLive = liveCompetitions?.scores.find(
      (item) => convertDataToUID(item.user.id) === hashUserLive,
    );
    const elementTarget = liveCompetitions?.scores.find(
      (item) => convertDataToUID(item.user.id) === hashUserTarget,
    );

    if (elementLive) {
      setLiveScore(elementLive.score);
    }
    if (elementTarget) {
      setTargetScore(elementTarget.score);
    }
  };
  const handleUpdateScoreBar = (): string => {
    let percentWidth: number;
    const total = liveScore + targetScore;
    if (liveData?.id === liveMatchData?.live.id) {
      percentWidth = (liveScore / total) * 100;
    } else {
      percentWidth = (targetScore / total) * 100;
    }

    if (total === 0) {
      return '50%';
    }
    return `${percentWidth}%`;
  };

  return (
    <>
      <div
        className="live-match-point"
        style={{
          backgroundColor:
            liveData?.id === liveMatchData?.live.id ? '#0079FF' : '#FF2063',
        }}
      >
        <div className="live-match-point_count-right">
          <div className="live-match-point_count-score">
            {liveData?.id === liveMatchData?.live.id ? targetScore : liveScore}
          </div>
          <ImageCustom className="live-match-diamond-icon" src={diamondIcon} />
        </div>
      </div>
      <div
        className="live-match-point-left"
        style={{
          width: handleUpdateScoreBar(),
          backgroundColor:
            liveData?.id === liveMatchData?.target.id ? '#0079FF' : '#FF2063',
        }}
      >
        <div className="live-match-point_count-left">
          <ImageCustom className="live-match-diamond-icon" src={diamondIcon} />
          <div className="live-match-point_count-score">
            {liveData?.id === liveMatchData?.target.id
              ? targetScore
              : liveScore}
          </div>
        </div>
        <div className="live-match-point_effect">
          <img src={pointEffectGif} alt="" />
        </div>
      </div>
    </>
  );
};
export default LiveMatchPoint;
